// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2LpW_","title":"ClientReferral_title__2Tx2q","itemText":"ClientReferral_itemText__MMlC9"};